// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"915020e4","2741":"8f15b9f2","5331":"915020e4","6075":"e999621b","9588":"915020e4"}[chunkId] + ".chunk.css";
};